export default "__VITE_ASSET__D$IDJhN$__"